module.exports = __webpack_public_path__ + "static/fitness_consultation_660-5a3c12d3934540bbc20bf141def1ce9d.jpg";